module.exports = __webpack_public_path__ + "static/img/img_warning_triangle_3d.9f54922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_warning_triangle_3d.png
// module id = 8nFN
// module chunks = 1